const generalNetworkError = 'Something went wrong, please try again later';

export default {
  generalNetworkError,
};
